export default __webpack_public_path__ + "static/media/app-showcase-image-04.570ab112.png";